import api from './api';

export const projectService = {
  getAll: (params = {}) => api.get('/projects', { params }),
  getById: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/admin/projects', data),
  update: (id, data) => api.put(`/admin/projects/${id}`, data),
  delete: (id) => api.delete(`/admin/projects/${id}`),
};

export const eventService = {
  getAll: (params = {}) => api.get('/events', { params }),
  getById: (id) => api.get(`/events/${id}`),
  create: (data) => api.post('/admin/events', data),
  update: (id, data) => api.put(`/admin/events/${id}`, data),
  delete: (id) => api.delete(`/admin/events/${id}`),
};

export const blogService = {
  getAll: (params = {}) => api.get('/blogs', { params }),
  getBySlug: (slug) => api.get(`/blogs/${slug}`),
  create: (data) => api.post('/admin/blogs', data),
  update: (id, data) => api.put(`/admin/blogs/${id}`, data),
  delete: (id) => api.delete(`/admin/blogs/${id}`),
};

export const galleryService = {
  getAll: (params = {}) => api.get('/gallery', { params }),
  getCategories: () => api.get('/gallery/categories'),
  upload: (data) => api.post('/admin/gallery', data),
  delete: (id) => api.delete(`/admin/gallery/${id}`),
};

export const donationService = {
  create: (data) => {
    if (data instanceof FormData) {
      return api.post('/donations', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return api.post('/donations', data);
  },
  getAll: (params = {}) => api.get('/admin/donations', { params }),
  getById: (id) => api.get(`/admin/donations/${id}`),
  updateStatus: (id, status) => api.put(`/admin/donations/${id}/status`, { status }),
};

export const campaignService = {
  getAll: (params = {}) => api.get('/campaigns', { params }),
  getById: (id) => api.get(`/campaigns/${id}`),
};

export const advisoryBoardService = {
  getAll: (params = {}) => api.get('/advisory-board', { params }),
};

export const popupAnnouncementService = {
  getAll: (params = {}) => api.get('/popup-announcements', { params }),
  getActive: () => api.get('/popup-announcements/active'),
  getBySlug: (slug) => api.get(`/popup-announcements/${slug}`),
};

export const homeSettingService = {
  get: () => api.get('/home-settings'),
};

export const contactService = {
  submit: (data) => api.post('/contacts', data),
  getAll: (params = {}) => api.get('/admin/contacts', { params }),
  getById: (id) => api.get(`/admin/contacts/${id}`),
  updateStatus: (id, status) => api.put(`/admin/contacts/${id}/status`, { status }),
};

export const volunteerService = {
  submit: (data) => api.post('/volunteers', data),
};

export const authService = {
  register: (data) => api.post('/auth/register', data),
  login: (email, password) => api.post('/auth/login', { email, password }),
  logout: () => api.post('/auth/logout'),
  getCurrentUser: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
  changePassword: (data) => api.post('/auth/change-password', data),
};

export const dashboardService = {
  getStats: () => api.get('/admin/dashboard/stats'),
  getActivities: (limit = 10) => api.get('/admin/dashboard/activities', { params: { limit } }),
};
